/**
 * Formats the backend defines itself rather than reading from Scryfall
 * legalities. Classic Legacy is a positive-only predicate: there is no
 * "not legal in" side, so the Legality control is hidden for it and
 * `formatLegality` never reaches the URL or the wire.
 */
export const CLASSIC_LEGACY_FORMAT = 'classic_legacy';

/**
 * Display labels for format wire values that should not render raw. Lowercase,
 * like every other format in the list (those render their wire value as is).
 */
export const FORMAT_LABELS: Record<string, string> = {
  [CLASSIC_LEGACY_FORMAT]: 'classic legacy',
};

/** Hover text for format options that need explaining. */
export const FORMAT_TITLES: Record<string, string> = {
  [CLASSIC_LEGACY_FORMAT]:
    'Unofficial format: Alpha through Rise of the Eldrazi, reprints allowed. classiclegacymtg.com',
};

export const formatLabel = (format: string): string => FORMAT_LABELS[format] ?? format;

/** False for formats whose legality cannot be inverted. */
export const formatHasLegality = (format: string): boolean =>
  format.toLowerCase() !== CLASSIC_LEGACY_FORMAT;
